module.exports = __webpack_public_path__ + "assets/images/404.3c1053f8b5866ad36db315656b9419fd.svg";